
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./elavon.cjs.production.min.js')
} else {
  module.exports = require('./elavon.cjs.development.js')
}
